<template>
	<div class="loadGeneralItems">
		<field
				v-if="loadTypeList"
				margin="0"
				label="Load type"
				placeholder="Select load type"
				@updateAutocomplete="onAutocomplete($event, 'load_type', 'load_type_id')"
				:autocompleteValue="{value:load.load_type, id:load.load_type_id}"
				:items="loadTypeList"
				:isClearable="false"
				is-autocomplete
				is-required
				:classError="hasErr('load_type_id')"
		></field>
		<field
				margin="0"
				label="Broker load"
				placeholder="Enter Broker load"
				@updateInput="onInput($event, 'broker_number')"
				:setInputValue="load.broker_number"
				is-required
				:classError="hasErr('broker_number')"
		></field>

		<field
				v-if="brokers"
				margin="0"
				label="Broker"
				placeholder="Select broker"
				@updateSearchText="onSearchText($event, 'broker')"
				@updateAutocomplete="onAutocomplete($event, 'broker_name', 'broker_id')"
				:autocompleteValue="{value:load.broker_name, id:load.broker_id}"
				:items="brokers"
				:isClearable="false"
				is-autocomplete
				is-required
				is-btn-autocomplete
				:classError="hasErr('broker_id')"
				:closeMenuOnBtnClick="true"
		></field>
		<field
				v-if="brokerMcFromList"
				margin="0"
				label="Broker MC"
				:setInputValue="brokerMcFromList"
				is-disabled
		/>

		<field
				v-else
				margin="0"
				label="Broker MC"
				placeholder="Enter Broker MC"
				@updateInput="onInput($event, 'mc')"
				:setInputValue="load.mc"
				is-required
				:classError="hasErr('mc')"
		/>
		<field
				margin="0"
				label="Rate"
				placeholder="Enter rate"
				type="number"
				@updateInput="onInput($event, 'rate')"
				:setInputValue="load.rate"
				icon="dollar"
				is-required
				:classError="hasErr('rate')"
		></field>
	</div>
</template>

<script>
import { loadType } from "@/components/Dispatch/Trips/DialogTrip/constants";

export default {
	name: "GeneralItems",
	props: {
		load: Object,
		brokers: Array,
		errors: Object,
	},
	computed: {
		loadTypeList() {
			return loadType;
		},
		brokerMcFromList() {
			if (!this.load?.broker_id || !Array.isArray(this.brokers)) return '';

			const broker = this.brokers.find(b => String(b.id) === String(this.load.broker_id));

			return String((broker && (broker.mc ?? broker.broker_mc ?? broker.mc_number)) || '').trim();
		},
	},
	data() {
		return {
			lastSyncedMc: '', // последнее mc, которое мы автоподставили из списка
			lastSyncedBrokerId: null,
		};
	},

	// watch: {
	// 	'load.broker_id': {
	// 		immediate: true,
	// 		handler(newVal, oldVal) {
	// 			const changed = String(newVal || '') !== String(oldVal || '');
	// 			this.syncBrokerMcToLoad({ brokerChanged: changed });
	// 			this.prevBrokerId = newVal;
	// 		},
	// 	},
	// 	brokers: {
	// 		immediate: true,
	// 		handler() {
	// 			// список приехал/обновился — но брокер мог не меняться
	// 			this.syncBrokerMcToLoad({ brokerChanged: false });
	// 		},
	// 	},
	// },
	methods: {
		hasErr(key) {
			return !!(this.errors && this.errors[key]);
		},
		onAutocomplete({ value }, key, id) {
			this.$emit('updateAutocomplete', { value, key, id });
		},
		onInput({ value }, key, parent) {
			this.$emit('updateInput', { value, key, parent });
		},
		onSearchText(name, key) {
			this.$emit('updateSearchText', { name, key });
		},

		// syncBrokerMcToLoad({ brokerChanged }) {
		// 	// брокер не выбран — чистим и сбрасываем "авто-след"
		// 	if (!this.load || !this.load.broker_id) {
		// 		this.$emit('updateInput', { value: '', key: 'mc' });
		// 		this.lastSyncedMc = '';
		// 		this.lastSyncedBrokerId = null;
		// 		return;
		// 	}
		//
		// 	if (!Array.isArray(this.brokers)) return;
		//
		// 	const mcFromList = this.brokerMcFromList; // '' если null/нет
		// 	const currentMc = String(this.load.mc || '').trim();
		// 	const lastMc = String(this.lastSyncedMc || '').trim();
		//
		// 	// ✅ если в списке есть MC — ставим его в load.mc
		// 	if (mcFromList) {
		// 		this.$emit('updateInput', { value: mcFromList, key: 'mc' });
		// 		this.lastSyncedMc = mcFromList;
		// 		this.lastSyncedBrokerId = this.load.broker_id;
		// 		return;
		// 	}
		//
		// 	// ✅ если MC нет в списке — разрешаем ввод
		// 	// но если брокер сменился, и в поле висит старый "авто-MC" — очищаем
		// 	if (brokerChanged && currentMc === lastMc) {
		// 		this.$emit('updateInput', { value: '', key: 'mc' });
		// 	}
		// }
	},
};
</script>

<style scoped lang="scss">
.loadGeneralItems {
	display: grid;
	grid-template-columns: 1fr 2fr 2fr 2fr 2fr;
	grid-gap: 10px;
}
</style>
